import { customAxios } from '../../common/customAxios';

interface postUsersOwnTractorsParams {
  reqBody: {
    brandId: string;
    model: string;
    engineOutputInPs: number;
    manufacturedYear: number;
    operationTime: number;
    marketPrice: number | null;
  };
}

export const postUsersOwnTractors = ({ reqBody }: postUsersOwnTractorsParams): Promise<void> => {
  return customAxios.post('/user-own-tractors', reqBody);
};
